// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Lodash
import map from "lodash/map";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
  * ServiceSchema - Implements schema.org Service
  *
  * Describes a service
  *
  * @example
    <ServiceSchema data={data}>
  *
  * @param {string} data.url - Required. The url of the page.
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://schema.org/Service|Schema.org Service Docs}
  */
var ServiceSchema = function ServiceSchema(props) {
  var data = props.data;


  var schemaOrgJSONLD = {
    "@context": "http://schema.org",
    "@type": "Service",
    serviceType: data.serviceHeading,
    provider: {
      "@type": "LocalBusiness",
      name: data.organization
    },
    areaServed: data.areaServed,
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: data.oneLiner,
      itemListElement: []
    }
  };
  map(data.services, function (_ref) {
    var serviceName = _ref.serviceName,
        serviceDescription = _ref.serviceDescription;

    schemaOrgJSONLD.hasOfferCatalog.itemListElement.push({
      "@type": "Offer",
      businessFunction: "http://purl.org/goodrelations/v1#" + data.businessFunction,
      itemOffered: {
        "@type": "Service",
        name: serviceName,
        description: serviceDescription
      },
      priceSpecification: {
        "@type": "PriceSpecification",
        minPrice: data.priceSpecification.minPrice,
        maxPrice: data.priceSpecification.maxPrice,
        priceCurrency: data.priceSpecification.priceCurrency,
        description: data.priceSpecification.priceDescription
      }
    });
  });
  // console.log(JSON.stringify(schemaOrgJSONLD));

  return React.createElement(
    Helmet,
    null,
    React.createElement(
      "script",
      { type: "application/ld+json" },
      JSON.stringify(schemaOrgJSONLD)
    )
  );
};

ServiceSchema.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object // eslint-disable-line react/forbid-prop-types
} : {};

ServiceSchema.defaultProps = {
  data: {
    author: ""
  }
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default ServiceSchema;